import React from 'react';
import Icon from '../Icon';
import { RequestTopic } from '../publicApi';
import { useContact } from '../SiteContent';
import ContactForm from './ContactForm';
import T from './EditableText';

interface ContactSectionProps {
  /** Abweichender Textschlüssel für die Überschrift des Blocks. */
  titleKey?: string;
  /** Abweichender Textschlüssel für den einleitenden Satz. */
  introKey?: string;
  /** Zuordnung der Anfrage im Posteingang. */
  topic?: RequestTopic;
}

/** Kontaktdaten als beschriftete Zeilen — auf mehreren Seiten identisch eingebunden. */
export const ContactDetails: React.FC = () => {
  const contact = useContact();

  return (
    <dl className="hx-contact-lines">
      <div>
        <dt><Icon name="map-pin" size={17} /><T k="kontakt.zeile.adresse" /></dt>
        <dd>
          <a href={contact.directionsHref} target="_blank" rel="noopener noreferrer">{contact.address}</a>
        </dd>
      </div>
      <div>
        <dt><Icon name="phone" size={17} /><T k="kontakt.zeile.telefon" /></dt>
        <dd><a href={contact.phoneHref}>{contact.phoneLabel}</a></dd>
      </div>
      <div>
        <dt><Icon name="message-circle" size={17} /><T k="kontakt.zeile.whatsapp" /></dt>
        <dd>
          <a href={contact.whatsappHref} target="_blank" rel="noopener noreferrer">{contact.whatsappLabel}</a>
        </dd>
      </div>
      <div>
        <dt><Icon name="mail" size={17} /><T k="kontakt.zeile.email" /></dt>
        <dd><a href={contact.emailHref}>{contact.email}</a></dd>
      </div>
    </dl>
  );
};

const ContactSection: React.FC<ContactSectionProps> = ({
  titleKey = 'kontaktblock.titel',
  introKey = 'kontaktblock.text',
  topic = 'CONTACT',
}) => (
  <section id="kontakt" className="section--tinted hx-contact-wrap" style={{ scrollMarginTop: 90 }}>
    <div className="shell section hx-contact">
      <div className="hx-contact__info">
        <h2 className="h-section">
          <T k={titleKey} />
        </h2>
        <p>
          <T k={introKey} />
        </p>
        <ContactDetails />
      </div>
      <div className="hx-contact__form">
        <ContactForm topic={topic} />
      </div>
    </div>
  </section>
);

export default ContactSection;
